import { Injectable } from '@angular/core';
import { Response, Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AlertController, Loading, LoadingController, ToastController } from 'ionic-angular';
import { Network } from '@ionic-native/network'

@Injectable()
export class GlobalService {

    //used as shared var between pages, to send data from any page to any page
    public tmpVar: any= null;
    public serverAddress: string = "http://service.soft-planning.com/api";

    private _debug: boolean = true;

    private loader: Loading;

    private jsonHeaders = new Headers({ 'Content-Type': 'application/json' });
    private urlEncodedHeaders = new Headers({
        'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        'Accept': 'application/json, text/javascript, */*'
    });

    constructor(private http: Http, private toastCtrl: ToastController,
        private loadingCtrl: LoadingController, private alertCtrl: AlertController,
        private network: Network) {

    }

    public debug(): boolean {
        return this._debug;
    }

    public log(name: any, value?: any) {
        if (!this._debug) return;
        if (arguments.length == 1) {
            console.log(name);
        }
        else {
            console.log(name, JSON.stringify(value));
        }
    }

    public showLoading(msg?: string): void {
        //init loader
        this.loader = this.loadingCtrl.create({
            content: msg ? msg : "رجاء الإنتظار ..."
        });
        this.loader.present();
    }

    public hideLoading(): void {
        if (!this.loader) return;
        this.loader.dismiss();
    }

    public post(url: string, data: any, success: (data: any) => void,
        faliure: (msg: string) => void, isJson: number): void {
        //
        if (!this.connected()) {
            this.toast('غير متصل بالشبكة');
            return;
        }
        //
        
        this.log('<== posting data \r\n' +
            url + '\r\n',
            data);
        //
        this.showLoading();
        this.http.post(this.serverAddress+ url, data,
            { headers: isJson ? this.jsonHeaders : this.urlEncodedHeaders })
            .toPromise()
            .then((res: Response) => {
                this.httpSuccess(res, success);
            })
            .catch((error: Error) => {
                this.handleHttpError(error, faliure);
            });
    }

    public get(url: string, success: (data: any) => void,
        faliure: (msg: string) => void): void {
        //
        if (!this.connected()) {
            this.toast('غير متصل بالشبكة');
            return;
        }
        
        this.log('<== getting data \r\n' +
            url + '\r\n');
        //
        this.showLoading();
        this.http.get(this.serverAddress+ url)
            .toPromise()
            .then((res: Response) => {
                this.httpSuccess(res, success);
            })
            .catch((error: Error) => {
                this.handleHttpError(error, faliure);
            });
    }


    private httpSuccess(res: any, successClbk: (data: any) => void): void {
        this.hideLoading();

        //
        this.log('==> success response \r\n', res);
        if (successClbk) {
            successClbk(res);
        }
    }

    private handleHttpError(error: Error, faliureClbk: (err: any) => void): void {
        this.hideLoading();
        //
        this.log('==> faliure response \r\n', error.message);
        
        
        this.toast('خطأ');
        
        //
        if (faliureClbk) {
            faliureClbk(error.message);
        }
    }

    //displaying info

    public toast(msg: string): void {
        let toast = this.toastCtrl.create({
            message: msg,
            duration: 3000,
            position: 'top',
            showCloseButton: true,
            closeButtonText: "إغلاق"
        });
        toast.present();
    }

    public validationMsg(msg: string) {
        this.toast(msg);
    }

    public connected(): boolean {
        //this requires the network-information plugin
        this.log("Network Type ==>", this.network.type);
        return this.network.type != "none";
        //return true;
    }

    infoMsg(title: string, msg: string, then: () => void): void {

        let alert = this.alertCtrl.create({
            title: title,
            subTitle: msg,
            buttons: [{
                text: 'موافق',
                handler: data => {
                    then();
                }
            }]
        });
        alert.present();
    }

    /**
     * confirm message box with Yes and No buttons, params are the title and 
     * body of the message and a callback 
     */
    confirmMsg(title: string, msg: string, then: (yes: boolean) => void) {

        let alert = this.alertCtrl.create({
            title: title,
            subTitle: msg,
            buttons: [{
                text: 'نعم',
                handler: data => {
                    then(true);
                }
            },
            {
                text: 'لا',
                handler: data => {
                    then(false);
                }
            }]
        });
        alert.present();
    }

    /**
     * stores any kind of value in localStorage as json string
     */
    store(key: string, obj: any): void {
        localStorage.setItem(
            key,
            JSON.stringify(obj)
        );
        
    }

    /**
     * gets the value in localStorage as any
     */
    retrieve(key: string): any {
        return JSON.parse(
            localStorage.getItem(key)
        );
    }

    /**
     * gets the value in localStorage casted to type T
     */
    retrieveAs<T>(key: string): T {
        return JSON.parse(
            localStorage.getItem(key)
        ) as T;
    }

}


// WEBPACK FOOTER //
// ./src/services/global.service.ts